import { render } from "./CarteArtiste.vue?vue&type=template&id=739f20fc&scoped=true"
import script from "./CarteArtiste.vue?vue&type=script&lang=js"
export * from "./CarteArtiste.vue?vue&type=script&lang=js"

import "./CarteArtiste.vue?vue&type=style&index=0&id=739f20fc&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739f20fc"]])

export default __exports__